const getDefaultState = () => ({
  status: null,
  token: '',
  // BEGIN::Added.by.KWShin.2025.04.17.
  serverMessage: '',
  // END::Added.by.KWShin.2025.04.17.
});

const state = getDefaultState();

const getters = {
  getAuth(state) {
    return state;
  },
  // BEGIN::Added.by.KWShin.2025.04.17.
  getServerMessage(state) {
    return state.serverMessage;
  },
  // END::Added.by.KWShin.2025.04.17.
};

const mutations = {
  authorize(state, auth) {
    state.status = auth.status;
    state.token = auth.token;
  },
  // BEGIN::Added.by.KWShin.2025.04.17.
  setServerMessage(state, msg) {
    state.serverMessage = msg;
  },
  setResponseStatus(state, status) {
    state.status = status;
  },
  // END::Added.by.KWShin.2025.04.17.
  reset(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  authorize({ commit }, auth) {
    commit('authorize', auth);
  },
  // BEGIN::Added.by.KWShin.2025.04.17.
  setServerMessage({ commit }, msg) {
    commit('setServerMessage', msg);
  },
  setResponseStatus({ commit }, status) {
    commit('setResponseStatus', status);
  },
  // END::Added.by.KWShin.2025.04.17.
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
